/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionResponsePaging } from '../../models/subscription-response-paging';

export interface GetSubscriptions$Params {
  activeSubscriptions: boolean;
  page: number;
  pageSize: number;
  orderBy?: string;
  filter?: string;
}

export function getSubscriptions(http: HttpClient, rootUrl: string, params: GetSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionResponsePaging>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptions.PATH, 'get');
  if (params) {
    rb.query('activeSubscriptions', params.activeSubscriptions, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionResponsePaging>;
    })
  );
}

getSubscriptions.PATH = '/api/memberships/subscriptions';
